(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["editorial-collection"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('editorial-collection')) {
    class EditorialCollection extends HTMLElement {
      connectedCallback() {
        // Pesta√±as
        this.querySelectorAll('[data-ec-tab]').forEach((tab) => {
          tab.addEventListener('click', () => this.select(tab.dataset.ecTab));
        });

        // V√≠deos: solo se reproducen los visibles (los de la otra versi√≥n, desktop/m√≥vil, no cargan)
        this.observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            const video = entry.target;
            if (entry.isIntersecting) {
              video.play().catch(() => {});
            } else {
              video.pause();
            }
          });
        }, { rootMargin: '200px 0px' });

        this.querySelectorAll('video').forEach((video) => {
          video.muted = true;
          this.observer.observe(video);
        });
      }

      disconnectedCallback() {
        this.observer?.disconnect();
      }

      select(index) {
        this.querySelectorAll('[data-ec-tab]').forEach((tab) => {
          const active = tab.dataset.ecTab === index;
          tab.classList.toggle('is-active', active);
          tab.setAttribute('aria-selected', active);
        });
        this.querySelectorAll('[data-ec-panel]').forEach((panel) => {
          panel.classList.toggle('is-hidden', panel.dataset.ecPanel !== index);
        });
        this.querySelectorAll('[data-ec-view-all]').forEach((link) => {
          link.classList.toggle('is-hidden', link.dataset.ecViewAll !== index);
        });
      }
    }

    customElements.define('editorial-collection', EditorialCollection);
  }

  } catch(e) { console.error(e); }
})();
})();
